import { render, staticRenderFns } from "./agam_BookReleaseDetails.vue?vue&type=template&id=207804a6&"
import script from "./agam_BookReleaseDetails.vue?vue&type=script&lang=js&"
export * from "./agam_BookReleaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./agam_BookReleaseDetails.vue?vue&type=style&index=0&id=207804a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports